import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const ZoomMeeting = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get all URL parameters
    const params = new URLSearchParams();
    searchParams.forEach((value, key) => {
      params.append(key, value);
    });

    // Redirect to static HTML page with parameters
    window.location.href = `/zoom-meeting.html?${params.toString()}`;
  }, [searchParams]);

  return (
    <div className="vh-100 w-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Redirecting to meeting...</p>
      </div>
    </div>
  );
};

export default ZoomMeeting;
